import { render, staticRenderFns } from "./noticeListPage.vue?vue&type=template&id=2dffa730&scoped=true&"
import script from "./noticeListPage.vue?vue&type=script&lang=js&"
export * from "./noticeListPage.vue?vue&type=script&lang=js&"
import style0 from "./noticeListPage.vue?vue&type=style&index=0&id=2dffa730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dffa730",
  null
  
)

export default component.exports